import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import PaymentConverterService from '~/api-services/PaymentConverterService';
import { ConfigData } from '~/api-services/PaymentConverterService/types';
import config from '~/config';
import OrderConvertService from "~/api-services/OrderConvertService";
import {PaymentProvider1MethodsV2} from "~/api-services/OrderConvertService/types";

export const usePaymentProvider1Methods = () => {
    const [paymentMethods, setPaymentMethods] = useState<PaymentProvider1MethodsV2>();

    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        const { status, data } = await OrderConvertService.getPaymentProvider1MethodsV2();
        if (status === 200 && data.status) {
            setPaymentMethods(data.returnData);
        }
    }

    return {
        paymentMethods,
    };
};
